(ns portal.resource.delivery
  (:require [camel-snake-kebab.core :as csk]
            [camel-snake-kebab.extras :as cske]
            [common.url-template :as url-tpl]
            [mate.re-frame :as mr]
            [re-frame.core :as rf]))

(defn get-all [effects token url-context {:keys [on-success on-failure]}]
  (-> effects
      (mr/conj-fx [:http
                   {:method :post
                    :uri (url-tpl/render :measure-api/usage-data url-context)
                    :params {:agency_id (:agency-id url-context)}
                    :headers {"Authorization" token}
                    :on-success on-success
                    :on-failure on-failure}])))

(defn get-details [effects token url-context {:keys [params on-success on-failure]}]
  (-> effects
      (mr/conj-fx [:http
                   {:method :post
                    :uri (url-tpl/render :measure-api/usage-details url-context)
                    :params (->> (merge params (select-keys url-context [:agency-id]))
                                 (cske/transform-keys csk/->snake_case))
                    :headers {"Authorization" token}
                    :response-format :binary+filename
                    :on-success on-success
                    :on-failure on-failure}])))

(rf/reg-sub :resource.delivery/all
  (fn [db _]
    (:resource.delivery/all db)))
